import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link } from 'react-router-dom';
import logo from '../img/logo.png'

function BasicExample() {
    const [expanded, setExpanded] = useState(false);

    const handleNavItemClick = () => {
        setExpanded(false);
    };

    return (
        <Navbar expand="lg" expanded={expanded} className="navigation">
            <Container>
                <Navbar.Brand as={Link} to="/" onClick={handleNavItemClick}>  <img src={logo}/>    </Navbar.Brand>
                <Navbar.Toggle
                    aria-controls="navbarSupportedContent"
                    onClick={() => setExpanded(!expanded)}
                />
                <Navbar.Collapse id="navbarSupportedContent">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/" className="color" onClick={handleNavItemClick}>Home</Nav.Link>

                        <Nav.Link as={Link} to="/About" className="color" onClick={handleNavItemClick}>About</Nav.Link>



                        {/* <NavDropdown title="Surgeries" id="basic-nav-dropdown" className="custom-dropdown-title">
                            <NavDropdown.Item as={Link} to="/Genitourinary" onClick={handleNavItemClick}>Genitourinary Surgery</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/Prostate" onClick={handleNavItemClick}>Prostate Laser Surgery</NavDropdown.Item>
                        </NavDropdown> */}

                        <NavDropdown title="Services" id="basic-nav-dropdown" className="custom-dropdown-title">
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Party Peeling for Instant Glow</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Chemical Peeling</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Electro Cautery</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Radio Cautery</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Mole Removing</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Skin Tag Removing</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Vitiligo Surgery</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>PUVA Therapy</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>PRP (Platelet Rich Plasma)</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Skin Rejuvenation</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Open Pores Treatment</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Laser Hair Removal</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Hydra Facial</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Scar Treatment</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Keloid Treatment</NavDropdown.Item>
                        </NavDropdown>


                        <Nav.Link as={Link} to="/Gallery" className="color" onClick={handleNavItemClick}>Gallery</Nav.Link>

                        <Nav.Link as={Link} to="/Appointment" className="color" onClick={handleNavItemClick}>Appointment</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default BasicExample;
